
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Nodata },
  props: {
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '报告期',
        dataIndex: 'Enddate',
        key: 'Enddate',
        width: '100px',
        fixed: 'left'
      },
      {
        title: '股东人数 (户)',
        dataIndex: 'SHNum',
        key: 'SHNum',
        slots: { customRender: 'peopleCount' },
        width: '110px',
        ellipsis: true
      },
      {
        title: '较上期变化',
        dataIndex: 'TheChange',
        key: 'TheChange',
        slots: { customRender: 'increase' },
        width: '110px',
        ellipsis: true
      },
      {
        title: '人均流通股 (股/户)',
        dataIndex: 'AFAverageHoldSum',
        key: 'AFAverageHoldSum',
        slots: { customRender: 'peopleCount' },
        width: '140px',
        ellipsis: true
      },
      {
        title: '较上期变化',
        dataIndex: 'AFAverageHoldSumChange',
        key: 'AFAverageHoldSumChange',
        slots: { customRender: 'increase' },
        width: '110px',
        ellipsis: true
      },
      {
        title: '股价(元)',
        dataIndex: 'ClosePrice',
        key: 'ClosePrice',
        slots: { customRender: 'ellipsis' },
        width: '100px',
        ellipsis: true
      },
      {
        title: '人均持股金额(元)',
        dataIndex: 'AverageHoldSumPrice',
        key: 'AverageHoldSumPrice',
        slots: { customRender: 'peopleCount' },
        width: '100px',
        ellipsis: true
      },
      {
        title: '十大股东持股合计',
        dataIndex: 'PCTOfTotalShares',
        key: 'PCTOfTotalShares',
        slots: { customRender: 'nocolorincrease' },
        width: '150px',
        ellipsis: true
      },
      {
        title: '十大流通股东持股合计',
        dataIndex: 'PCTOfTotalSharesStream',
        key: 'PCTOfTotalSharesStream',
        slots: { customRender: 'nocolorincrease' },
        width: '160px',
        ellipsis: true
      }
    ]
    watch(
      () => (props.pageSourceData || {}).Shareholder || [],
      () => {
        const _data = (props.pageSourceData || {}).Shareholder || []
        if (_data.length) {
          _data.forEach((item: any) => {
            item.Enddate = window.moment(item.EndDate * 1000).format('YYYY-MM-DD')
          })
        }
        nextTick(() => {
          pageData.spinning = false
        })
        pageData.data = _data
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
